import type { Database } from '@/types/supabase';
import { createClient } from '@supabase/supabase-js';
import globalData from '../globals';

export const supabaseUrl =
	globalData?.config?.supabaseUrl ?? 'https://xyzcompany.supabase.co';
// Prefer the new publishable key; fall back to the legacy anon-key alias.
// Either format (sb_publishable_… or the legacy anon JWT) works unchanged here.
export const supabaseKey =
	globalData?.config?.supabasePublishableKey ??
	globalData?.config?.supabaseAnonKey ??
	'public-anon-key';

// Auth uses the supabase-js defaults (localStorage-backed storage,
// persistSession, autoRefreshToken) so the session survives reloads,
// new tabs, and browser restarts.
export const supabase = createClient< Database >( supabaseUrl, supabaseKey );
